import Vue from 'vue'
import { VueQueryPlugin, QueryClient, hydrate } from '@tanstack/vue-query'
import { Context } from '@nuxt/types'

export default (context: Context) => {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { enabled: !process.server } },
  })

  if (process.server && context.ssrContext) {
    ;(context.ssrContext as any).VueQuery = queryClient
  }

  if (process.client) {
    Vue.use(VueQueryPlugin, { queryClient })

    if (context.nuxtState && context.nuxtState.vueQueryState) {
      hydrate(queryClient, context.nuxtState.vueQueryState)
    }
  }
}
